export default __webpack_public_path__ + "static/media/mysql-icon.e5a509a5.svg";